export default __webpack_public_path__ + "static/media/placeholder_dummy2016-fotograf04-de.dbe98851.png";